// ============================================
// 2026-10-16（P2 性能档联动）：一键档位 → 批改渲染/后期/阴影（纯函数，可单测）
// 高：分辨率 1 + SSAO/抗锯齿 + 阴影 4096；中：分辨率 1 + 抗锯齿 + 阴影 2048；低：0.75 + 全关 + 阴影 1024
// ============================================
export type PerformanceTier = 'high' | 'medium' | 'low';

export interface PerformanceTierPatch {
  postprocessing: {
    resolutionScale: number;
    ssao: { enabled: boolean };
    antialiasing: { enabled: boolean };
    bloom: { enabled: boolean };
    dof: { enabled: boolean };
    grain: { enabled: boolean };
    vignette: { enabled: boolean };
  };
  shadow: { mapSize: number };
  /** 2026-10-19（S4）：体积雾盒 raymarch 采样步数（性能档联动；应用到全部 fogBox） */
  volumetrics: { fogSteps: number };
}

export function performanceTierPatch(tier: PerformanceTier): PerformanceTierPatch {
  const base = {
    postprocessing: {
      resolutionScale: 1,
      ssao: { enabled: false },
      antialiasing: { enabled: true },
      bloom: { enabled: false },
      dof: { enabled: false },
      grain: { enabled: false },
      vignette: { enabled: false },
    },
    shadow: { mapSize: 2048 },
    volumetrics: { fogSteps: 32 },
  };
  if (tier === 'high') {
    return { ...base, postprocessing: { ...base.postprocessing, ssao: { enabled: true } }, shadow: { mapSize: 4096 }, volumetrics: { fogSteps: 48 } };
  }
  if (tier === 'low') {
    return { ...base, postprocessing: { ...base.postprocessing, resolutionScale: 0.75, antialiasing: { enabled: false } }, shadow: { mapSize: 1024 }, volumetrics: { fogSteps: 16 } };
  }
  return base;
}
